export const BrandCodes = ['CBA', 'CBR', 'ERA', 'BHG', 'C21', 'CMP'] as const;
export type BrandCode = (typeof BrandCodes)[number];
